import { type SvgIconProps } from '@common/components/svgs/props';

function IconStatusAlert(
  { size = 24, color = 'scheme-feedback-warning-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Alert"
    >
      <path d="M11 16L11 14L13 14L13 16L11 16Z" fill={`var(--${color})`} />
      <path d="M11 7L11 12.5L13 12.5L13 7L11 7Z" fill={`var(--${color})`} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconStatusAlert.displayName = 'Status-Alert';

export default IconStatusAlert;
